import { render, staticRenderFns } from "./LoanReports.vue?vue&type=template&id=6fa5bde8&scoped=true"
import script from "./LoanReports.vue?vue&type=script&lang=js"
export * from "./LoanReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa5bde8",
  null
  
)

export default component.exports